var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5328 3.20996H9.75781C8.93281 3.20996 8.25781 3.88496 8.25781 4.70996V43.71C8.25781 44.535 8.93281 45.21 9.75781 45.21H39.1578C39.9828 45.21 40.6578 44.535 40.6578 43.71V13.68C40.6578 13.29 40.5078 12.915 40.2378 12.645L31.6128 3.67496C31.3278 3.37496 30.9378 3.20996 30.5328 3.20996Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4578 35.5348C30.7124 35.5348 35.7828 30.4644 35.7828 24.2098C35.7828 17.9551 30.7124 12.8848 24.4578 12.8848C18.2032 12.8848 13.1328 17.9551 13.1328 24.2098C13.1328 30.4644 18.2032 35.5348 24.4578 35.5348Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 18.8102C30.4451 18.3452 29.6351 18.4202 29.1701 18.9752L22.5851 26.8502L19.6001 24.3452C19.0451 23.8802 18.2351 23.9552 17.7701 24.5102C17.3051 25.0652 17.3801 25.8752 17.9351 26.3402L21.8651 29.6252C22.4501 30.0902 23.2901 30.0152 23.7851 29.4602L31.1801 20.6402C31.6451 20.0852 31.5701 19.2752 31.0301 18.8102H31.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.409124b416468a30f14272413876ba77.svg";
export { ForwardRef as ReactComponent };